export default function throttleWait<T extends Function>(fn: T) {
  let isCalled = false
  return function (
    wait: number,
    ...args: T extends (...args: infer A) => void ? A : never
  ) {
    if (!isCalled) {
      fn(...args)
      isCalled = true
      setTimeout(function () {
        isCalled = false
      }, wait)
    }
  }
}
